/**
 * =============================================================================
 * stockist-locator.js 
 * =============================================================================
 * 
 * =============================================================================
 */

var StockistLocator = {
  data: {
    selectors: {
      map: "mp-map",
      accordion_item_template: "#mp-template-tile-accordion-item",
      grid_item_template: "#mp-template-tile-grid-item",
      accordion_container: ".mp-accordion",
      grid_container: "#mp-stockists-grid",
      search_form: "#mp-stockist-search",
      reset_button: "#mp-stockist-reset",
      stockist_entry: ".mp-stockist-entry"
    },

    stockists: [],
    map: null,
    markers: [],
    initialBounds: null,
    ready: false,
    firstTime: true
  },

  templates: {
    accordion_item: null,
    grid_item: null
  },

  endpoint: null,

  // Build geocode endpoint URL with API key from config
  getGeocodeUrl: function(address) {
    var apiKey = window.STOCKIST_LOCATOR_CONFIG?.geocodingApiKey || "";
    if (!apiKey) {
      console.error("Geocoding API key is not configured. Please add your Geocoding API key in theme settings.");
      return null;
    }
    var encodedAddress = encodeURIComponent(address);
    return `https://maps.googleapis.com/maps/api/geocode/json?key=${apiKey}&address=${encodedAddress}`;
  },

  onReady: function() {
    var that = this;

    // Only on stockist page...
    if(MP.Utilities.isStockistLocatorPage()){
      // Compile Lodash template
      this.templates.accordion_item = _.template($(this.data.selectors.accordion_item_template).text());

      // Prevent search form default event
      $(this.data.selectors.search_form).on('submit', function(e) { e.preventDefault(); });

      // Reset the stockist locator when 'Reset' button clicked - show all, fit map to original bounds
      $(this.data.selectors.reset_button).on('click', function(e) { 
        e.preventDefault();
        $('.mp-accordion').addClass('d-none');
        that.data.map.fitBounds(that.data.initialBounds);
        $('input', that.data.selectors.search_form).val('');
        $(that.data.selectors.stockist_entry).removeClass('d-none');
        $(this).addClass('d-none');
      });

      // Try to get current location when map is ready (event-driven)
      if(navigator.geolocation) {
        // Listen for map ready event instead of polling
        document.addEventListener('stockist-map:ready', function() {
          // Show loading state for geolocation
          $('#mp-stockist-current-message').html('<span class="mp-loading-spinner"></span> Getting your location...');
          
          navigator.geolocation.getCurrentPosition(
            that.onGetCurrentPosition.bind(that),
            function(error) {
              // Handle geolocation errors silently - it's optional functionality
              var errorMessage = "Unable to get your location: ";
              switch(error.code) {
                case error.PERMISSION_DENIED:
                  errorMessage += "Location access denied.";
                  break;
                case error.POSITION_UNAVAILABLE:
                  errorMessage += "Location information unavailable.";
                  break;
                case error.TIMEOUT:
                  errorMessage += "Location request timed out.";
                  break;
                default:
                  errorMessage += "Unknown error.";
                  break;
              }
              console.warn("StockistLocator Geolocation:", errorMessage);
              // Reset message - geolocation is optional
              $('#mp-stockist-current-message').html("Use the search bar to find locations near you, or browse the map.");
            },
            {
              timeout: 10000,
              enableHighAccuracy: false
            }
          );
        }, { once: true });
      }
    } else if(MP.Utilities.isAllStockistsPage()) {
      this.templates.grid_item = _.template($(this.data.selectors.grid_item_template).text());
    }
  },

  onGetCurrentPosition: function(position) {
    var that = this;
    var positionFromBrowser = {lat: position.coords.latitude, lng: position.coords.longitude};

    // Calculate distance from position to marker lat lng using Haversine formula
    this.data.markers.forEach(function(marker) {
      marker.distance = that.getDistanceFromLatLonInKm(positionFromBrowser.lat, positionFromBrowser.lng, marker.position.lat(), marker.position.lng())
    });

    // Get the 10 closest markers
    var tenClosestMarkers = this.getNClosestStockistsBounds(positionFromBrowser, 10);
    if(tenClosestMarkers[0].distance > 50){
      this.showOutOfBounds();
    } else {
      this.hideOutOfBounds();
      var newBounds = new google.maps.LatLngBounds();
      tenClosestMarkers.forEach(function(marker) {
        newBounds.extend(marker.position);
      });

      this.data.map.fitBounds(newBounds, 0);
      this.onMapBoundsChange();
    }
  },

  showOutOfBounds: function() {
    $('#mp-stockists-out-of-bounds').removeClass('d-none');
    $(this.data.selectors.reset_button)[0].click();
  },

  hideOutOfBounds: function() {
    $('#mp-stockists-out-of-bounds').addClass('d-none');
  },

  // Show loading state
  showLoading: function(message) {
    message = message || "Loading...";
    var loadingHtml = '<span class="mp-loading-spinner"></span>' + message;
    if ($('#mp-stockist-current-message').length) {
      $('#mp-stockist-current-message').html(loadingHtml);
    }
  },

  // Hide loading state
  hideLoading: function() {
    // Loading will be replaced by actual content
  },

  // Fetch stockists from JSON file provided from section settings
  getStockists: function(endpoint) {
    var that = this;
    this.endpoint = endpoint;
    
    if (!endpoint) {
      this.handleStockistError("Stockist data URL is not configured.");
      return;
    }

    // Show loading state
    this.showLoading("Loading stockist locations...");

    $.ajax({
      url: endpoint,
      method: 'GET',
      dataType: 'json',
      timeout: 10000, // 10 second timeout
      success: function(data) {
        if (!data || !data.stockists || !Array.isArray(data.stockists)) {
          that.handleStockistError("Invalid stockist data format received.");
          return;
        }
        that.onFetchedStockists(data);
      },
      error: function(xhr, status, error) {
        var errorMessage = "Failed to load stockist data.";
        
        if (status === "timeout") {
          errorMessage = "Request timed out. Please check your connection and try again.";
        } else if (status === "error") {
          if (xhr.status === 0) {
            errorMessage = "Network error. Please check your connection.";
          } else if (xhr.status === 404) {
            errorMessage = "Stockist data file not found. Please check the configuration.";
          } else if (xhr.status >= 500) {
            errorMessage = "Server error. Please try again later.";
          } else {
            errorMessage = "Error loading stockist data (Status: " + xhr.status + ").";
          }
        }
        
        that.handleStockistError(errorMessage);
      }
    });
  },

  // Handle stockist loading errors
  handleStockistError: function(message) {
    console.error("StockistLocator Error:", message);
    
    // Update UI to show error message
    var errorHtml = '<div class="alert alert-danger" role="alert">' +
      '<strong>Error:</strong> ' + message +
      '</div>';
    
    // Try to show error in the stockist message area
    if ($('#mp-stockist-current-message').length) {
      $('#mp-stockist-current-message').html(errorHtml);
    } else {
      // Fallback: show alert
      alert("Stockist Locator Error: " + message);
    }
    
    // Hide loading state
    $('.mp-accordion').addClass('d-none');
  },

  // Add markers to the map (event-driven, called when stockists are loaded)
  addMarkersToMap: function() {
    if(this.data.stockists.length === 0 || !this.data.map) {
      return;
    }

    var that = this;
    that.data.initialBounds = new google.maps.LatLngBounds();

    var infowindow = new google.maps.InfoWindow();

    that.data.stockists.forEach(function(item, index) {
      // Validate coordinates
      var lat = parseFloat(item.lat);
      var lng = parseFloat(item.lng);
      
      if (isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
        console.warn("StockistLocator: Invalid coordinates for stockist", item.name, "lat:", item.lat, "lng:", item.lng);
        return; // Skip invalid entries
      }

      // Create an infowindow
      var contentString = '<div class="mp-map-infowindow"><h4>' + item.name + '</h4><p>' + item.address + ' ' + item.post_code + '</p></div>';

      // Create a marker
      var position = { lat: lat, lng: lng };
      var marker = new google.maps.Marker({
        position: position,
        title: item.name,
        icon: "https://cdn.shopify.com/s/files/1/0029/6619/2195/files/map-marker.png?v=1591357501",
        index: index
      });

      // Assign the infowindow to the marker, show on click
      marker.addListener('click', function() {
        infowindow.setContent(contentString);
        infowindow.open(that.data.map, marker);
      });

      // Store a reference to our marker
      that.data.markers.push(marker)

      that.data.initialBounds.extend(position);
    });

    var clusterOptions = {
      styles: [
        {
          url: "https://cdn.shopify.com/s/files/1/0029/6619/2195/files/m1.png",
          width: 57,
          height: 57,
          anchorText: [-1,1],
          fontFamily: "Georgia,Times,Times New Roman,serif",
          textSize: 15,
          fontWeight: "normal"
        }
      ]
    };

    // Only proceed if we have valid markers
    if (that.data.markers.length === 0) {
      console.warn("StockistLocator: No valid markers to display");
      that.handleStockistError("No valid stockist locations found in the data.");
      return;
    }

    try {
      // Show loading state while adding markers
      $('#mp-stockist-current-message').html('<span class="mp-loading-spinner"></span> Adding locations to map...');
      
      var markerCluster = new MarkerClusterer(that.data.map, that.data.markers, clusterOptions);
      that.data.map.fitBounds(that.data.initialBounds, 0);
      that.data.ready = true;

      that.data.map.addListener('idle', function() {
        that.onMapBoundsChange();
      });

      // Dispatch event that map is ready for geolocation
      var mapReadyEvent = new CustomEvent('stockist-map:ready');
      document.dispatchEvent(mapReadyEvent);
    } catch (error) {
      console.error("StockistLocator: Error adding markers to map", error);
      that.handleStockistError("Error displaying stockist locations on map.");
    }
  },

  // Show map loading overlay
  showMapLoading: function() {
    var loadingOverlay = document.getElementById('mp-map-loading');
    if (loadingOverlay) {
      loadingOverlay.style.display = 'flex';
    }
  },

  // Hide map loading overlay
  hideMapLoading: function() {
    var loadingOverlay = document.getElementById('mp-map-loading');
    if (loadingOverlay) {
      loadingOverlay.style.display = 'none';
    }
  },

  // Setup the google map
  initMap: function() {
    var that = this;
    var mapElement = document.getElementById(this.data.selectors.map);
    
    if (!mapElement) {
      console.error("StockistLocator: Map element not found");
      this.handleStockistError("Map container not found. Please refresh the page.");
      return;
    }

    // Show map loading overlay
    this.showMapLoading();

    try {
      this.data.map = new google.maps.Map(mapElement, {
        center: {lat: 56.4907, lng: -4.2026},
        zoom: 7
      });

      // Hide loading overlay when map is ready
      this.data.map.addListener('tilesloaded', function() {
        that.hideMapLoading();
      });
    } catch (error) {
      console.error("StockistLocator: Failed to initialize map", error);
      this.handleStockistError("Failed to initialize map. Please refresh the page.");
      return;
    }

    $(this.data.selectors.search_form).on('submit', function(e) {      
      var searchString = $('input', this).val();
      if(searchString == ""){
        return;
      }

      var requestUrl = that.getGeocodeUrl(searchString);
      if (!requestUrl) {
        that.handleGeocodeError("Geocoding API key is not configured. Please contact the site administrator.");
        return;
      }

      // Show loading state with spinner
      var searchButton = $(this).find('button');
      var originalButtonText = searchButton.html();
      searchButton.prop('disabled', true).html('<span class="mp-loading-spinner"></span> Searching...');
      $('#mp-stockist-current-message').html('<span class="mp-loading-spinner"></span> Searching for location...');

      $.ajax({
        url: requestUrl,
        method: 'GET',
        dataType: 'json',
        timeout: 10000, // 10 second timeout
        success: function(response) {
          // Restore button state
          searchButton.prop('disabled', false).html(originalButtonText);
          that.onGeocode(response);
        },
        error: function(xhr, status, error) {
          // Restore button state
          searchButton.prop('disabled', false).html(originalButtonText);
          
          var errorMessage = "Failed to search for location.";
          
          if (status === "timeout") {
            errorMessage = "Search request timed out. Please check your connection and try again.";
          } else if (status === "error") {
            if (xhr.status === 0) {
              errorMessage = "Network error. Please check your connection.";
            } else if (xhr.status === 403) {
              errorMessage = "Geocoding API access denied. Please check API key configuration.";
            } else if (xhr.status >= 500) {
              errorMessage = "Geocoding service error. Please try again later.";
            } else {
              errorMessage = "Error searching for location (Status: " + xhr.status + ").";
            }
          }
          
          that.handleGeocodeError(errorMessage);
        }
      });
    }); 

    // If stockists are already loaded, add markers immediately
    if(this.data.stockists.length > 0) {
      this.addMarkersToMap();
    }

  },

  // Handle geocoding errors
  handleGeocodeError: function(message) {
    console.error("Geocoding Error:", message);
    
    // Update UI to show error message
    $('#mp-stockist-current-message').html(
      '<span class="text-danger">' + message + '</span>'
    );
  },

  // Handle a geocode response
  onGeocode: function(response) {
    if(!response || !response.status) {
      this.handleGeocodeError("Invalid response from geocoding service.");
      return;
    }

    // Handle different Google Geocoding API status codes
    if(response.status === "ZERO_RESULTS") {
      this.handleGeocodeError("No results found for that location. Please try a different search term.");
      return;
    }
    
    if(response.status === "OVER_QUERY_LIMIT") {
      this.handleGeocodeError("Geocoding service quota exceeded. Please try again later.");
      return;
    }
    
    if(response.status === "REQUEST_DENIED") {
      this.handleGeocodeError("Geocoding request denied. Please check API key configuration.");
      return;
    }
    
    if(response.status === "INVALID_REQUEST") {
      this.handleGeocodeError("Invalid search request. Please try a different search term.");
      return;
    }
    
    if(response.status !== "OK") {
      this.handleGeocodeError("Unable to find that location. Please try a different search term.");
      return;
    }

    if(!response.results || !response.results[0] || !response.results[0].geometry || !response.results[0].geometry.location) {
      this.handleGeocodeError("Invalid location data received.");
      return;
    }

    var that = this;
    var position = response.results[0].geometry.location;

    // Get the 10 closest markers
    var tenClosestMarkers = this.getNClosestStockistsBounds(position, 10);
    if(tenClosestMarkers[0].distance > 50){
      this.showOutOfBounds();
    } else {
      this.hideOutOfBounds();
      var newBounds = new google.maps.LatLngBounds();
      tenClosestMarkers.forEach(function(marker) {
        newBounds.extend(marker.position);
      });

      this.data.map.fitBounds(newBounds, 0);
      this.onMapBoundsChange();
    }
  },

  getNClosestStockistsBounds: function(position, n) {
    var that = this;

    // Calculate distance from position to marker lat lng using Haversine formula
    this.data.markers.forEach(function(marker) {
      marker.distance = that.getDistanceFromLatLonInKm(position.lat, position.lng, marker.position.lat(), marker.position.lng())
    });

    return this.data.markers.sort(function(a, b) {
      return parseFloat(a.distance) - parseFloat(b.distance);
    }).slice(0, n);
  },

  getDistanceFromLatLonInKm: function(lat1,lon1,lat2,lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
    var dLon = this.deg2rad(lon2-lon1); 
    var a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2)
      ; 
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    var d = R * c; // Distance in km
    return d;
  },

  deg2rad: function(deg) {
    return deg * (Math.PI/180)
  },

  // Update the visible stockists when the map changes
  onMapBoundsChange: function() {
    var visibleMarkers = 0;
    var that = this;

    // Has the page just loaded? If so, don't show the big list
    if(!this.data.firstTime){
      $('.mp-accordion').removeClass('d-none');
    } else {
      this.data.firstTime = false;
    }
    
    // Update the accordion by showing / hiding drawers by whether their marker
    // is in bounds
    this.data.markers.forEach(function(item, index) {
      if(that.data.map.getBounds().contains(item.getPosition())){
        visibleMarkers += 1;
        $("#mp-stockist-" + item.index).removeClass("d-none");
      } else {
        $("#mp-stockist-" + item.index).addClass("d-none");
      }
    });

    if(visibleMarkers > 0) {

      // Attach distance to stockist entries - just for debug
      $(".mp-stockist-entry").each(function(index, element) {
        var distance = that.data.markers.find(function(item) {
          return item.index == parseInt($(element).attr('data-mp-index'));
        }).distance;
        $(element).attr('data-mp-distance', distance);
        $('.mp-stockist-distance', element).text((parseFloat(distance).toFixed(1)) + "km");
      });

      // Order the stockist entry accordion drawers by distance from center
      $(".mp-stockist-entry").sort(function(a,b) { 
        var aMarker = that.data.markers.find(function(item) {
          return item.index == parseInt($(a).attr('data-mp-index'));
        });
        var bMarker = that.data.markers.find(function(item) {
          return item.index == parseInt($(b).attr('data-mp-index'));
        });
        return aMarker.distance - bMarker.distance;
      }).appendTo('.mp-accordion');

      // Update messaging
      var message = "Showing " + visibleMarkers + " locations(s)";
      if(visibleMarkers === this.data.markers.length) {
        $('.mp-accordion').addClass('d-none');
        message = "Use the search bar to find locations near you. or browse the map.";
      }
      $('#mp-stockist-current-message').html(message);
    } else {
      $('#mp-stockist-current-message').html("No locations found");
    }

    if(visibleMarkers !== this.data.markers.length){
      $(this.data.selectors.reset_button).removeClass('d-none');
    }
  },

  // Compile Lodash template with stockist info from JSON and setup accordion
  onFetchedStockists: function(response) {
    var that = this;
    this.data.stockists = response.stockists.sort(function(a, b) {
      if(a.name.trim() < b.name.trim()){
        return -1;
      }
      if(a.name.trim() > b.name.trim()){
        return 1;
      }
      return 0;
    });
    this.data.stockists.forEach(function(item, index) {
      var templateData = _.assign({ 
        name: "",
        address: "",
        address_2: "",
        address_3: "",
        city: "",
        county: "",
        country: "",
        post_code: "",
        phone: "",
        lat: "",
        lng: "",
        distance: "XX",
        id: index
      }, item)

      if(MP.Utilities.isStockistLocatorPage()) {
        var html = that.templates.accordion_item(templateData);
        $(that.data.selectors.accordion_container).append(html);
        $('.mp-marker-icon', '#mp-stockist-'+ index).on('click', function(e) {
          that.zoomToMarker(index);
        });
      } else if(MP.Utilities.isAllStockistsPage()) {
        var html = that.templates.grid_item(templateData);
        $(that.data.selectors.grid_container).append(html);
      }
    });

    // Event-driven: Add markers to map if map is already initialized
    // If map isn't ready yet, initMap will call addMarkersToMap when it's created
    if(this.data.map) {
      this.addMarkersToMap();
    }
  },

  zoomToMarker: function(index) {
    var position = this.data.markers[index].position;
    var bounds = new google.maps.LatLngBounds({ lat: position.lat() - 0.1, lng: position.lng() - 0.1 }, { lat: position.lat() + 0.1, lng: position.lng() + 0.1 });
    this.data.map.fitBounds(bounds, 0);
    google.maps.event.trigger(this.data.markers[index], 'click');
  }
};

export default StockistLocator